// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Qr_fullscreenContainer__wcaY2 {
  position: fixed; /* Фиксируем контейнер */
  top: 0; /* Занимаем всю высоту экрана */
  left: 0; /* Занимаем всю ширину экрана */
  width: 100%; /* Полная ширина */
  height: 100%; /* Полная высота */
  background-color: rgba(0, 0, 0, 0.8); /* Темный фон с прозрачностью */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000; /* Делаем контейнер поверх других элементов */
}

.Qr_video__\\+jqW7 {
  /* transform: scale(2);  */
  /* transform-origin: center; */
  width: 100%; /* Полная ширина */
  height: 100%; /* Полная высота */
  object-fit: cover; /* Обеспечиваем полное заполнение экрана */
}


.Qr_fullscreenContainer__wcaY2 {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column; /* Элементы располагаются сверху вниз */
  /* Легкое затемнение основного контейнера */
  /* background-color: rgba(107, 107, 107, 0.2);  */
}

.Qr_video__\\+jqW7 {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.Qr_scanArea__HNbfK {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 300px;
  height: 300px;
  transform: translate(-50%, -50%);
  /* Легкое затемнение краев  */
  box-shadow: 0 0 0 200vw rgba(34, 34, 34, 0.4), 0 0 0 200vh rgba(34, 34, 34, 0.4); 
}

.Qr_corner__WwR1E {
  border-radius: 8%;
  position: absolute;
  width: 40px; 
  height: 40px;
  border: 3px solid #167c6c;
}

.Qr_videoContainer__N2Atf {
  position: relative;
  width: 100%;
  height: calc(100vh - 60px); /* Высота, исключающая верхнюю полосу */
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(34, 34, 34, 0.4); /* Затемнение области видео */
}

.Qr_corner__WwR1E.Qr_top-left__ayKQJ {
  top: -3px;
  left: -3px;
  border-right: none;
  border-bottom: none;
}

.Qr_corner__WwR1E.Qr_top-right__GoB64 {
  top: -3px;
  right: -3px;
  border-left: none;
  border-bottom: none;
}

.Qr_corner__WwR1E.Qr_bottom-left__Tf2zK {
  bottom: -3px;
  left: -3px;
  border-right: none;
  border-top: none;
}

.Qr_corner__WwR1E.Qr_bottom-right__3Axkz {
  bottom: -3px;
  right: -3px;
  border-left: none;
  border-top: none;
}

.Qr_topBar__Mv2oE {
  width: 100%;
  height: 60px; /* Высота полосы */
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1); /* Легкая тень для верхней полосы */
  z-index: 10; /* Чтобы полоска оставалась поверх остальных элементов */
}

.Qr_logo__4EhOF {
  height: 30px; /* Размер логотипа */
}

.Qr_closeButton__fBFZa {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #000;
}
.Qr_logo__4EhOF {
  height: 40px; /* Размер логотипа */
}
.Qr_closeButton__fBFZa {
  background-color: #bbbbbb;
  width: 30px; /* Увеличиваем ширину кнопки */
  height: 30px; /* Увеличиваем высоту кнопки */
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #f8f8f8;
  display: flex;
  justify-content: center;
  align-items: center; /* Выровнять крестик по центру */
  border-radius: 10%; /* Для закругления кнопки */
}

.Qr_zoomContainer__bV\\+Nf {
  position: absolute; /* Расположить над видео */
  bottom: 15%; /* Расположить ближе к низу экрана */
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000; /* Убедитесь, что инпут поверх */
  background-color: rgba(0, 0, 0, 0.5); /* Полупрозрачный фон для улучшения видимости */
  padding: 10px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

input[type="range"] {
  z-index: 10000;
  width: 200px; /* Можно настроить ширину */
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/Qr/index.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe,EAAE,wBAAwB;EACzC,MAAM,EAAE,+BAA+B;EACvC,OAAO,EAAE,+BAA+B;EACxC,WAAW,EAAE,kBAAkB;EAC/B,YAAY,EAAE,kBAAkB;EAChC,oCAAoC,EAAE,+BAA+B;EACrE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,6CAA6C;AAC9D;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,WAAW,EAAE,kBAAkB;EAC/B,YAAY,EAAE,kBAAkB;EAChC,iBAAiB,EAAE,0CAA0C;AAC/D;;;AAGA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB,EAAE,uCAAuC;EAC/D,2CAA2C;EAC3C,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,6BAA6B;EAC7B,gFAAgF;AAClF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,0BAA0B,EAAE,uCAAuC;EACnE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uCAAuC,EAAE,6BAA6B;AACxE;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY,EAAE,kBAAkB;EAChC,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,2CAA2C,EAAE,mCAAmC;EAChF,WAAW,EAAE,wDAAwD;AACvE;;AAEA;EACE,YAAY,EAAE,oBAAoB;AACpC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;AACA;EACE,YAAY,EAAE,oBAAoB;AACpC;AACA;EACE,yBAAyB;EACzB,WAAW,EAAE,8BAA8B;EAC3C,YAAY,EAAE,8BAA8B;EAC5C,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAE,gCAAgC;EACrD,kBAAkB,EAAE,2BAA2B;AACjD;;AAEA;EACE,kBAAkB,EAAE,0BAA0B;EAC9C,WAAW,EAAE,oCAAoC;EACjD,SAAS;EACT,2BAA2B;EAC3B,cAAc,EAAE,gCAAgC;EAChD,oCAAoC,EAAE,+CAA+C;EACrF,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,YAAY,EAAE,2BAA2B;EACzC,gBAAgB;AAClB","sourcesContent":[".fullscreenContainer {\n  position: fixed; /* Фиксируем контейнер */\n  top: 0; /* Занимаем всю высоту экрана */\n  left: 0; /* Занимаем всю ширину экрана */\n  width: 100%; /* Полная ширина */\n  height: 100%; /* Полная высота */\n  background-color: rgba(0, 0, 0, 0.8); /* Темный фон с прозрачностью */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000; /* Делаем контейнер поверх других элементов */\n}\n\n.video {\n  /* transform: scale(2);  */\n  /* transform-origin: center; */\n  width: 100%; /* Полная ширина */\n  height: 100%; /* Полная высота */\n  object-fit: cover; /* Обеспечиваем полное заполнение экрана */\n}\n\n\n.fullscreenContainer {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  flex-direction: column; /* Элементы располагаются сверху вниз */\n  /* Легкое затемнение основного контейнера */\n  /* background-color: rgba(107, 107, 107, 0.2);  */\n}\n\n.video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.scanArea {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 300px;\n  height: 300px;\n  transform: translate(-50%, -50%);\n  /* Легкое затемнение краев  */\n  box-shadow: 0 0 0 200vw rgba(34, 34, 34, 0.4), 0 0 0 200vh rgba(34, 34, 34, 0.4); \n}\n\n.corner {\n  border-radius: 8%;\n  position: absolute;\n  width: 40px; \n  height: 40px;\n  border: 3px solid #167c6c;\n}\n\n.videoContainer {\n  position: relative;\n  width: 100%;\n  height: calc(100vh - 60px); /* Высота, исключающая верхнюю полосу */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(34, 34, 34, 0.4); /* Затемнение области видео */\n}\n\n.corner.top-left {\n  top: -3px;\n  left: -3px;\n  border-right: none;\n  border-bottom: none;\n}\n\n.corner.top-right {\n  top: -3px;\n  right: -3px;\n  border-left: none;\n  border-bottom: none;\n}\n\n.corner.bottom-left {\n  bottom: -3px;\n  left: -3px;\n  border-right: none;\n  border-top: none;\n}\n\n.corner.bottom-right {\n  bottom: -3px;\n  right: -3px;\n  border-left: none;\n  border-top: none;\n}\n\n.topBar {\n  width: 100%;\n  height: 60px; /* Высота полосы */\n  background-color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 20px;\n  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1); /* Легкая тень для верхней полосы */\n  z-index: 10; /* Чтобы полоска оставалась поверх остальных элементов */\n}\n\n.logo {\n  height: 30px; /* Размер логотипа */\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #000;\n}\n.logo {\n  height: 40px; /* Размер логотипа */\n}\n.closeButton {\n  background-color: #bbbbbb;\n  width: 30px; /* Увеличиваем ширину кнопки */\n  height: 30px; /* Увеличиваем высоту кнопки */\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #f8f8f8;\n  display: flex;\n  justify-content: center;\n  align-items: center; /* Выровнять крестик по центру */\n  border-radius: 10%; /* Для закругления кнопки */\n}\n\n.zoomContainer {\n  position: absolute; /* Расположить над видео */\n  bottom: 15%; /* Расположить ближе к низу экрана */\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10000; /* Убедитесь, что инпут поверх */\n  background-color: rgba(0, 0, 0, 0.5); /* Полупрозрачный фон для улучшения видимости */\n  padding: 10px;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\ninput[type=\"range\"] {\n  z-index: 10000;\n  width: 200px; /* Можно настроить ширину */\n  margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullscreenContainer": `Qr_fullscreenContainer__wcaY2`,
	"video": `Qr_video__+jqW7`,
	"scanArea": `Qr_scanArea__HNbfK`,
	"corner": `Qr_corner__WwR1E`,
	"videoContainer": `Qr_videoContainer__N2Atf`,
	"top-left": `Qr_top-left__ayKQJ`,
	"top-right": `Qr_top-right__GoB64`,
	"bottom-left": `Qr_bottom-left__Tf2zK`,
	"bottom-right": `Qr_bottom-right__3Axkz`,
	"topBar": `Qr_topBar__Mv2oE`,
	"logo": `Qr_logo__4EhOF`,
	"closeButton": `Qr_closeButton__fBFZa`,
	"zoomContainer": `Qr_zoomContainer__bV+Nf`
};
export default ___CSS_LOADER_EXPORT___;
